import * as React from 'react';
const SvgForward = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="m15.69 9.5-2.963 2.963a.75.75 0 0 0 .977 1.133l.084-.073 4.242-4.242a.75.75 0 0 0 .073-.977l-.073-.084-4.242-4.243a.75.75 0 0 0-1.134.977l.073.084L15.69 8H10a7.75 7.75 0 0 0-7.746 7.504l-.004.247a.75.75 0 0 0 1.5 0 6.25 6.25 0 0 1 6.02-6.246L10 9.5z"
    />
  </svg>
);
export default SvgForward;
